import { createContext, useContext } from "react";
import { AppConfig } from ".";

export const GlobalConfig = createContext({} as AppConfig);

export const useConfig = () => useContext(GlobalConfig);
